import React from 'react';
import { Box, Button, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { WarningIcon } from './AdminIcon';

export default function ManagementWarning({ title, children, onCancel, onContinue }) {
  return <Box maxW="3xl" bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="xl" overflow="hidden">
    <VStack align="stretch" spacing={4} p={{ base: 4, md: 6 }}>
      <HStack align="start" spacing={3}>
        <WarningIcon color="orange.600" boxSize={6} mt={0.5} />
        <Heading as="h2" size="md">{title}</Heading>
      </HStack>
      <Text color="gray.600" lineHeight="tall">{children}</Text>
    </VStack>
    <Flex justify="flex-end" gap={3} p={{ base: 4, md: 6 }} borderTopWidth="1px" borderColor="gray.200" bg="gray.50" wrap="wrap">
      <Button variant="outline" onClick={onCancel}>Cancel</Button>
      <Button variant="solid" colorScheme="blue" onClick={onContinue}>Continue</Button>
    </Flex>
  </Box>;
}
